module.exports = __webpack_public_path__ + "static/DaniloJiménezsub-75299608702187a40c06bc2b241b7f70.mp4";